<template>
  <GreyBarWithTitleAndValue
      is-with-borders
      title = "Departures per Month"
      :value = "$numberManagement.numberWithComma(itemData)"
  />
</template>

<script>

import GreyBarWithTitleAndValue from '../../../microcomponents/GreyBarWithTitleAndValue.vue';

export default {
  name: 'GrayBarDeparturesPerMonth',
  components: {
    GreyBarWithTitleAndValue,
  },

  props: {
    itemData: {
      type: [Number, String],
      default: null,
    },
  },
};
</script>
